import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useNoteDetail = (note) => {
  const fields = useSelector((state) => state.fields?.data.data);

  const noteData = useMemo(() => {
    if (!note) return null;

    const selectedField = fields?.find(
      (field) => field?.id === note?.field?.id,
    );

    const formattedImages =
      note?.photo?.map((photo, index) => {
        const imageUrl = photo?.photo;

        return {
          id: photo.id || `${note?.id}-${index}`,
          name: photo.name || `Foto ${index + 1}`,
          size: photo.size || 0,
          type: photo.type || "image/jpeg",
          preview: imageUrl,
          url: imageUrl,
        };
      }) || [];

    return {
      hasPhotos: note?.photo && note?.photo.length > 0,
      hasPosition: Boolean(note?.position),
      formattedImages,
      fieldPolygon: selectedField?.polygon || null,
      fieldCenter: selectedField?.polygon?.[0] || [40.0647, 9.1217],
      isDisease: note?.note_type === "DISEASE_REPORT",
    };
  }, [note, fields]);

  return noteData;
};
